import { render } from "./Header.vue?vue&type=template&id=73dca47c&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=73dca47c&scoped=true&lang=css"

import exportComponent from "/Users/rhylton/Sites/caxias-pedal/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73dca47c"]])

export default __exports__